import { render, staticRenderFns } from "./noticesdetailsdata.vue?vue&type=template&id=5b145796&"
import script from "./noticesdetailsdata.vue?vue&type=script&lang=js&"
export * from "./noticesdetailsdata.vue?vue&type=script&lang=js&"
import style0 from "./noticesdetailsdata.vue?vue&type=style&index=0&id=5b145796&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports